<template>
  <div>
    <Loading v-if="isLoading"></Loading>
    <section v-if="!isLoading" class="product">
      <div class="row">
        <div
          style="max-height: 600px;"
          class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6 product-show"
        >
          <!-- <ImageBox :item="product"></ImageBox> -->
          <div class="image-container">
            <img
              width="400"
              height="400"
              v-bind:src="
                'https://ardunic-images.s3.eu-central-1.amazonaws.com/' + image
              "
            />
          </div>
          <div class="images-slid product-show mt-4" style="    padding: 20px;">
            <swiper class="swiper" :options="swiperOption">
              <swiper-slide v-for="img in product.images" v-bind:key="img">
                <img
                  v-bind:style="[
                    image == img ? { borderBottom: '4px solid #5659ce' } : {},
                  ]"
                  style="padding-bottom: 8px; cursior: pointer"
                  @click="image = img"
                  width="100px"
                  height="100px"
                  v-bind:src="
                    'https://ardunic-images.s3.eu-central-1.amazonaws.com/' +
                      img
                  "
                />
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
          </div>
        </div>
        <div class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6">
          <div class="title-price ml-2">
            <p style="width: 500px" class="title h1">
              {{ product.title }}
              <span style="margin-top: .5rem!important;" class="sub-title">{{
                product.serialNumber
              }}</span>
              <span class="sub-title mt-2">
                in stock:
                <span v-if="product.stock > 0" style="color: green">
                  Avaliable
                  <img src="https://img.icons8.com/fluent/20/000000/ok.png" />
                </span>
                <!-- && (product.types || []).length === 0 -->
                <span v-if="product.stock === 0" style="color: red">
                  Unavailable
                  <img
                    src="https://img.icons8.com/fluent/20/000000/close-window.png"
                  />
                </span>
              </span>
            </p>
            <div v-if="product.stock > 0" class="prices" style="display: flex">
              <button
                v-bind:style="[
                  product.discountPercentage
                    ? { textDecoration: 'line-through' }
                    : {},
                ]"
                style="disply: flex; justify-content: center; align-items: center; font-size: 1.2rem; padding: 5px; font-weight: normal;"
                class="botn botn-blue"
              >
                {{ product.price.showPrice | toCurrency }} IQD
              </button>
              <button
                v-if="product.discountPercentage"
                style="disply: flex; margin-left: 5px; justify-content: center; align-items: center; font-size: 1.2rem; padding: 5px; font-weight: normal;"
                class="botn botn-red"
              >
                {{
                  (product.price.showPrice -
                    product.price.showPrice *
                      (product.discountPercentage / 100))
                    | toCurrency
                }}
                IQD
              </button>
            </div>
            <div
              v-if="product.stock == 0 && (product.types || []).length == 0"
              class="out"
              style="color: red ; font-size: 1.4rem"
            >
              <button
                v-bind:style="[
                  product.discountPercentage
                    ? { textDecoration: 'line-through' }
                    : {},
                ]"
                style="background: linear-gradient(to right, rgb(255, 84, 175), red);
;disply: flex;justify-content: center; align-items: center; font-size: 1.2rem; padding: 5px; font-weight: normal;"
                class="botn botn-blue"
              >
                Out of Stock
              </button>
            </div>
          </div>
          <div class="paragraph ml-2">{{ product.shortDescription }}</div>
          <div class="options ml-2">
            <div class="row" style="    justify-content: left;">
              <!-- <div class="col-6 col-md-3 col-lg-3">
              <button class="btn btn-outline-secondary" style="color: black; display: flex">
                Color
                <span id="chipss" style="margin-left: 20px; font-size: 18px; color: white">.</span>
              </button>
            </div>
            <div class="col-6 col-md-3 col-lg-3">
              <button class="btn btn-outline-secondary" style="color: black">10 ohm</button>
            </div>
            <div class="col-6 col-md-3 col-lg-3">
              <button class="btn btn-outline-secondary" style="color: black">op1</button>
              </div>-->
              <div v-if="product.stock > 0 || (product.types || []).length > 0">
                <div
                  style="
            display: flex;
            align-items: center;"
                  class="col-6 col-md-3 col-lg-3"
                >
                  <span
                    style="font-size: 20px; font-weight: 500; margin-right: 3px"
                    >Quantity:</span
                  >
                  <button
                    id="changeQTY"
                    class="btn btn-outline-secondary"
                    style="display: flex; padding: 4px"
                  >
                    <span
                      id="chipss2"
                      style="margin-right: 20px; font-size: 18px; color: white"
                      @click="quentityDecress"
                      >-</span
                    >
                    <span class="qtyy" style="font-size: 18px;">{{
                      quentity
                    }}</span>
                    <span
                      id="chipss"
                      style="margin-left: 20px; font-size: 18px; color: white"
                      @click="quentityIncress"
                      >+</span
                    >
                  </button>
                </div>
              </div>
              <!-- <div v-if="product.stock == 0" class="out" style="color: red ; font-size: 1.4rem">
                      Out of Stock
              </div>-->
            </div>
          </div>
          <div class="row mt-5">
            <div class="parent">
              <div
                class="centered box"
                style="margin-left: 10px; justify-content: left"
              >
                <div
                  v-if="product.stock > 0 || (product.types || []).length > 0"
                >
                  <button
                    style="  background: linear-gradient(to right, #05cefc, #5659ce);      margin: 0px 10px 0px 10px;"
                    @click="addToCart(product._id)"
                    class="ardunictn red"
                  >
                    <img
                      width="25"
                      src="@/assets/svg/Ardunic Elements-171.svg"
                      alt
                    />
                  </button>
                </div>
                <a
                  v-if="product.aboutProduct.doc"
                  style="  background: linear-gradient(to right, #f6893a, #fdbd5d);     margin: 0px 10px 0px 10px;"
                  :href="checkIfHasHTTP(product.aboutProduct.doc)"
                  target="_blank"
                  class="ardunictn red"
                >
                  <img
                    width="25"
                    src="@/assets/svg/Ardunic Elements-181.svg"
                    alt
                  />
                </a>
                <a
                  v-if="product.aboutProduct.video"
                  style="  background: linear-gradient(to right, #ff54af, red);     margin: 0px 10px 0px 10px;"
                  :href="checkIfHasHTTP(product.aboutProduct.video)"
                  target="_blank"
                  class="ardunictn red"
                >
                  <img
                    width="25"
                    src="@/assets/svg/Ardunic Elements-191.svg"
                    alt
                  />
                </a>
              </div>
            </div>
          </div>
          <div
            v-if="(product.types || []).length > 0"
            class="row mt-4 ml-2 mr-2"
          >
            <h4 style=" display: block; width: 100%">
              Types
            </h4>
            <div
              class="flexed-container"
              style="width: 100%; display: flex; flex-wrap: wrap;"
            >
              <div
                v-for="type in product.types"
                v-bind:key="type._id"
                v-bind:style="selectedTypeVar === type._id ? styleObject2 : ''"
                style=" margin:5px;
                        border: 1px solid rgb(193, 194, 197);
                        border-radius: 15px; 
                        text-align: center;
                        border-radius: 15px; "
                class="item mb-4 "
              >
                <div class="d-flex flex-column">
                  <div class="d-flex p-3">
                    <div class="type-img" style="width: 65px; height: 65px">
                      <img
                        width="100%"
                        height="100%"
                        v-bind:src="
                          'https://ardunic-images.s3.eu-central-1.amazonaws.com/' +
                            type.image
                        "
                      />
                    </div>
                    <div
                      class="d-flex flex-column justify-content-start align-items-start"
                      style="padding-left:10px"
                    >
                      <div
                        class="info"
                        style="font-weight: 500; font-size: 16px;"
                      >
                        {{ type.groupName }} : {{ type.value }}
                      </div>
                      <div class="price">
                        <h5
                          style="text-align: center; font-weight: bold; font-size: 16px;"
                        >
                          {{
                            (type.price + product.price.showPrice) | toCurrency
                          }}
                          IQD
                        </h5>
                      </div>
                    </div>
                  </div>
                  <div
                    class="p-2 d-flex"
                    style="padding-top:10px; border-top: 1px solid #DADADC;"
                  >
                    <div style="display: flex" class="actions">
                      <button
                        v-if="type.stock > 0"
                        style="background: linear-gradient(to right, #05cefc, #5659ce);"
                        @click="selectedTypeVar = type._id"
                        class="add-to-cart red"
                      >
                        {{ type.selected ? "Remove from cart" : "Add to cart" }}
                      </button>
                      <div
                        v-if="type.stock === 0"
                        style="  background: linear-gradient(to right, rgb(255, 84, 175), red);"
                        class="add-to-cart red"
                      >
                        Unavailable
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row mt-5">
          <div class="col-12 col-md-3">
            <ul class="sections pr-5">
              <li @click="descriptionN" class="section-item">
                <img
                  class="mr-2"
                  src="@/assets/svg/Ardunic Elemnts round 2-01.svg"
                  alt
                />
                <p class="h3">Description</p>
              </li>
              <li @click="downloadsN" class="section-item active">
                <img
                  class="mr-2"
                  src="@/assets/svg/Ardunic Elemnts round 2-02.svg"
                  alt
                />
                <p class="h3">Downloads</p>
              </li>
              <li @click="tutN" class="section-item">
                <img src="@/assets/svg/Ardunic Elemnts round 2-03.svg" />
                <p class="h3">Tutorials</p>
              </li>
              <li
                v-if="
                  product.aboutProduct.video != '' ||
                    product.aboutProduct.video != null
                "
                @click="videosN"
                class="section-item"
              >
                <img src="@/assets/svg/Ardunic Elemnts round 2-04.svg" />
                <p class="h3">Videos</p>
              </li>
              <li @click="reviewsN" class="section-item">
                <img src="@/assets/svg/Ardunic Elemnts round 2-05.svg" />
                <p class="h3">Reviews</p>
              </li>
              <li @click="showFAQs" class="section-item">
                <img src="@/assets/svg/faqs.svg" />
                <p class="h3">FAQs</p>
              </li>
            </ul>
          </div>
          <div v-if="downloads" class="col-md-9 product-show">
            <ul class="outline-none mx-4 my-2">
              <li
                class="mb-2"
                v-for="down in product.aboutProduct.downloads"
                v-bind:key="down._id"
              >
                <div
                  class="download-item"
                  style="border-bottom: 1px solid #c1c2c5;"
                >
                  <span>{{ down.name }}</span>
                  <span>
                    <a :href="down.url">link to download</a>
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        width="16"
                        height="16"
                        viewBox="0 0 172 172"
                        style=" fill:#000000;"
                      >
                        <g
                          fill="none"
                          fill-rule="nonzero"
                          stroke="none"
                          stroke-width="1"
                          stroke-linecap="butt"
                          stroke-linejoin="miter"
                          stroke-miterlimit="10"
                          stroke-dasharray
                          stroke-dashoffset="0"
                          font-family="none"
                          font-weight="none"
                          font-size="none"
                          text-anchor="none"
                          style="mix-blend-mode: normal"
                        >
                          <path d="M0,172v-172h172v172z" fill="none" />
                          <g fill="#2ecc71">
                            <path
                              d="M41.29505,117.175h32.87995v-107.5h23.65v107.5h32.87995l-44.70495,44.70495z"
                            />
                            <path
                              d="M96.75,10.75v105.35v2.15h2.15h29.2099l-42.1099,42.1099l-42.1099,-42.1099h29.2099h2.15v-2.15v-105.35h21.5M98.9,8.6h-25.8v107.5h-34.4l47.3,47.3l47.3,-47.3h-34.4v-107.5z"
                            />
                          </g>
                        </g>
                      </svg>
                    </span>
                  </span>
                </div>
              </li>
            </ul>
          </div>
          <div v-if="description" class="col-md-9 product-show">
            <div style="padding: 1.5rem" v-html="product.longDescription"></div>
          </div>
          <div v-if="videos" class="col-md-9 product-show">
            <iframe
              style="width: 100%; height: 350px;"
              v-bind:src="
                'https://www.youtube.com/embed/' + product.aboutProduct.video
              "
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
          <div v-if="faqs" class="col-md-9">
            <div class="product-show">
              <div style="padding: 1.5rem" v-html="product.QnA"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row mt-5 mx-2">
          <div class="col-md-2">
            <div style="border-right: 1px solid #c1c2c5">
              <img
                style=" display: block;width: 60px"
                src="@/assets/svg/Ardunic Elements-26.svg"
                alt
              />
              Tags
            </div>
          </div>
          <div class="col-md-10">
            <div class="tags">
              <span
                v-for="tag in tags"
                v-bind:key="tag._id"
                style="margin: 3px"
              >
                <span
                  style="font-size: 1.1rem; cursor: pointer ;    display: initial;"
                  @click="navigateTga(tag._id)"
                  v-bind:style="{
                    color: 'white',
                    height: 20 + 'px',
                    backgroundImage:
                      'linear-gradient(to right,' +
                      tag.first +
                      ',' +
                      tag.second +
                      ' )',
                  }"
                  class="badge"
                  >#{{ tag.name }}</span
                >
              </span>
            </div>
          </div>
        </div>
        <div class="row mt-5">
          <div class="col-12">
            <div class="wrapper">
              <div class="banner">
                <button
                  type="button"
                  style="width: 450px;
                         height: 45px;
                         color: white;
                         background: linear-gradient(to right, #f6893a, #fdbd5d); "
                  class="botn"
                >
                  Related Items
                </button>
              </div>
              <div class="cards-display-grid">
                <products-card
                  v-for="(product, index) in activeRelatedOnce"
                  :key="`${index}--INDEX__PRODUCT`"
                  :product="product"
                  class="card-new animatee"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ImageBox from "../components/Utilities/Share/ImageBox";
import router from "../router";
import Loading from "./Loading";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
// import carousel from 'vue-owl-carousel'
import Swal from "sweetalert2";
import axios from "axios";
import ProductsCard from "../components/Utilities/Cards/Products.vue";

export default {
  components: {
    Loading,
    ImageBox,
    Swiper,
    ProductsCard,
    SwiperSlide,
  },
  // props:[
  //   'slug'
  // ],
  data() {
    return {
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 20,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      colors: [
        { first: "#ff0400", second: "#ffcf69" },
        { first: "#c7f1ff", second: "#00d6ff" },
        { first: "#02b718", second: "#00d6ff" },
        { first: "#f16522", second: "#ffcf69" },
        { first: "#ff2cc6", second: "#ffcf69" },
      ],
      selectedTypeVar: null,
      isLoading: true,
      relateds: [],
      quentity: 1,
      product: [],
      faqs: false,
      description: true,
      downloads: false,
      tut: false,
      videos: false,
      reviews: false,
      activeRelatedOnce: [],
      image: null,
      conditions: [
        {
          id: 1,
          question:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Egestas ultricies lectus ornare sed leo arcu, ac ipsum. Ris, iaculis lorem etiam aliquam ut mattis sapien amet odio. Ornare maecenas praesent sed augue?",
          answer: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lacus, neque mi aliquam blandit lacus. Faucibus lorem consectetur vel nibh non lacus tincidunt neque. Nulla lorem et vivamus sit tincidunt leo. At sed curabitur senectus nulla. Aliquam, bibendum tempus malesuada orci, est. Urna quis sagittis, placerat mauris.
Felis massa, id ac amet, aliquet erat lacus. Blandit urna consequat, sit tortor a dignissim massa. Amet tristique dolor viverra sit vitae quis. Ipsum.`,
        },
        {
          id: 2,
          question:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Egestas ultricies lectus ornare sed leo arcu, ac ipsum. Ris, iaculis lorem etiam aliquam ut mattis sapien amet odio. Ornare maecenas praesent sed augue?",
          answer: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lacus, neque mi aliquam blandit lacus. Faucibus lorem consectetur vel nibh non lacus tincidunt neque. Nulla lorem et vivamus sit tincidunt leo. At sed curabitur senectus nulla. Aliquam, bibendum tempus malesuada orci, est. Urna quis sagittis, placerat mauris.
Felis massa, id ac amet, aliquet erat lacus. Blandit urna consequat, sit tortor a dignissim massa. Amet tristique dolor viverra sit vitae quis. Ipsum.`,
        },
        {
          id: 3,
          question:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Egestas ultricies lectus ornare sed leo arcu, ac ipsum. Ris, iaculis lorem etiam aliquam ut mattis sapien amet odio. Ornare maecenas praesent sed augue?",
          answer: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lacus, neque mi aliquam blandit lacus. Faucibus lorem consectetur vel nibh non lacus tincidunt neque. Nulla lorem et vivamus sit tincidunt leo. At sed curabitur senectus nulla. Aliquam, bibendum tempus malesuada orci, est. Urna quis sagittis, placerat mauris.
Felis massa, id ac amet, aliquet erat lacus. Blandit urna consequat, sit tortor a dignissim massa. Amet tristique dolor viverra sit vitae quis. Ipsum.`,
        },
      ],
      currentId: 0,
      styleObject2: {
        border: "2px solid #40c140",
        borderRadius: "15px",
      },
      styleObject: {
        color: "white",
        height: "20px",
        background: ` linear-gradient(to right, #${Math.floor(
          100000 + Math.random() * 900000
        )}, #${Math.floor(100000 + Math.random() * 900000)})`,
        margin: "0px 5px 0px 5px",
      },
    };
  },
  created() {
    this.getProduct();
    // if (this.product.types) {
    //   this.selectedTypeVar = this.product.types._id;
    // }
  },
  computed: {
    tags() {
      return this.product.tags.map((tag) => {
        const randomGradiant = this.colors[
          Math.floor(Math.random() * this.colors.length)
        ];
        const colors = {
          first: randomGradiant.first,
          second: randomGradiant.second,
        };
        Object.assign(tag, colors);
        return tag;
      });
    },
  },

  methods: {
    async getProduct() {
      await axios
        .get(`https://api.ardunic.com/v1/product/${this.$route.params.slug}`)
        .then((res) => {
          setTimeout(() => {
            this.image = res.data.data.images[0];
            // if (res.data.data.types != "") {
            //   this.selectedTypeVar = res.data.data.types[0]._id;
            // }
            res.data.data.types.forEach((type) => {
              type.selected = false;
            });
            this.isLoading = false;
          }, 1500);
          setTimeout(() => {
            this.product = res.data.data;
            this.getRelatedProducts(res.data.data._id);
            if (this.product.types.length) {
              this.selectedTypeVar = this.product.types[0]._id;
            }
          }, 2000);
        });
    },

    getRelatedProducts(id) {
      axios
        .get(`https://api.ardunic.com/v1/product/related/${id}`)
        .then((res) => {
          this.activeRelatedOnce = res.data.data;
        });
    },
    // selectAtype(id){
    //   this.product.types.filter(type => {
    //     if (type._id == id) {
    //       if (type.selected) {
    //         type.selected = false;
    //       }else{
    //         type.selected = true;
    //       }
    //     }
    //     type.selected = false;
    //   })
    // },
    navigate(slug) {
      router.push({ path: `/product/${slug}` });
      location.reload();
    },
    navigateTga(id) {
      router.push({ path: `/tag/${id}` });
      // console.log(slug);
    },
    selectedType(id) {
      let type = this.product.types.filter((t) => {
        return t._id == id;
      });
      type[0].selected = true;
    },
    quentityIncress() {
      if (this.selectedTypeVar) {
        let type = this.product.types.filter((t) => {
          return t._id == this.selectedTypeVar;
        });

        if (this.quentity >= type[0].stock) {
          return 0;
        } else {
          this.quentity++;
        }
      } else {
        if (this.quentity >= this.product.stock) {
          return 0;
        } else {
          this.quentity++;
        }
      }
    },
    quentityDecress() {
      if (this.quentity == 1) {
        return 0;
      } else {
        this.quentity--;
      }
    },
    async addToCart(productId) {
      if (
        this.product.stock == 0 &&
        (this.product.types || []).length > 0 &&
        this.selectedTypeVar == ""
      ) {
        Swal.fire({
          position: "centertop-end",
          icon: "error",
          width: "20rem",
          title: "you need to select a type !",
          showConfirmButton: true,
        });
      } else {
        let data = {
          productId,
          totalQuantities: this.quentity,
          priceIds: [],
        };
        // this.product.types.forEach((type) => {
        //   if(type.selected) data.priceIds.push(type._id);
        // })
        let totalPrice = this.product.price.showPrice;
        if (this.selectedTypeVar != "") {
          this.product.types.forEach((type) => {
            if (type._id == this.selectedTypeVar) {
              data.priceIds.push(type._id);
              totalPrice += type.price;
            }
          });
        }
        if ((this.selectedTypeVar = "" && this.product.types)) {
          data.priceIds.push(this.product.types[0]._id);
          totalPrice += this.product.types[0].price;
        }
        axios
          .post("https://api.ardunic.com/v1/cart", data, {
            headers: {
              access_token: localStorage.getItem("token"),
            },
          })
          .then(() => {
            Swal.fire({
              position: "top-end",
              icon: "success",
              width: "20rem",
              title: this.product.title + " has been added to cart",
              showConfirmButton: false,
              timer: 1500,
            });
            this.$store.dispatch("addToCardIncrease", {
              qty: this.quentity,
              price:
                (this.product.discountPercentage
                  ? totalPrice -
                    totalPrice * (this.product.discountPercentage / 100)
                  : totalPrice) * this.quentity,
              softAdd: true,
            });
          })
          .catch((error) => {
            Swal.fire({
              position: "center",
              icon: "error",
              title: error.response.data.message,
            });
          });
      }
    },
    descriptionN() {
      this.description = true;
      this.downloads = false;
      this.tut = false;
      this.videos = false;
      this.faqs = false;
      this.reviews = false;
    },
    downloadsN() {
      this.description = false;
      this.downloads = true;
      this.tut = false;
      this.videos = false;
      this.faqs = false;
      this.reviews = false;
    },
    tutN() {
      this.description = false;
      this.downloads = false;
      this.tut = true;
      this.videos = false;
      this.faqs = false;
      this.reviews = false;
    },
    videosN() {
      this.description = false;
      this.downloads = false;
      this.tut = false;
      this.videos = true;
      this.faqs = false;
      this.reviews = false;
    },
    reviewsN() {
      this.description = false;
      this.downloads = false;
      this.tut = false;
      this.videos = false;
      this.faqs = false;
      this.reviews = true;
    },
    showFAQs() {
      this.description = false;
      this.downloads = false;
      this.tut = false;
      this.videos = false;
      this.reviews = false;
      this.faqs = true;
    },
    checkIfHasHTTP(str) {
      return !str.startsWith("http") ? `http://${str}` : str;
    },
  },
  watch: {
    $route() {
      this.isLoading = true;
      this.getProduct();
    },
  },
};
</script>

<style scoped>
.swiper-button-prev:after,
.swiper-button-next:after {
  font-size: 16px;
  font-weight: bold;
}

.swiper-container {
  padding-bottom: 16px;
}

.swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: 1px solid #c1c2c5;
}

.swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: -5px;
}
.product {
  margin: 120px 40px;
}

.sections {
  list-style: none;
}
.banner {
  text-align: center;
  margin-bottom: 60px;
  margin-top: -60px;
}

.price h5 {
  color: rgb(26, 91, 211);
  text-align: right;
  font-size: 20px;
  font-weight: bolder;
}
.cards-display-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.wrapper {
  border: 1px solid #c1c2c5;
  border-radius: 20px;
  padding: 30px 30px 30px 30px;
}

.section-item {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #c1c2c5;
}

.section-item img {
  width: 30px;
}

.section-item p {
  padding-top: 15px;
  margin-left: 10px;
}
.outline-none {
  list-style: none;
}

.download-item {
  display: flex;
  justify-content: space-between;
}

.parent {
  width: 100%;
  height: 100%;
  position: relative;
}

.centered {
  /* position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  -webkit-transform: translateY(-50%) translateX(-50%);
  -moz-transform: translateY(-50%) translateX(-50%);
  -ms-transform: translateY(-50%) translateX(-50%);
  -o-transform: translateY(-50%) translateX(-50%);
  text-align: center; */
  display: flex;
  justify-content: center;
}

.product-show {
  border-radius: 20px;
  border: 1px solid #c1c2c5;
  padding: 0;
}
.btn {
  border-radius: 15px;
}

#chipss {
  background: linear-gradient(right, #ff3fbb, #ff8891);
  border-radius: 60%;
  width: 25px;
  text-align: center;
}

#chipss2 {
  background: linear-gradient(to right, #05cefc, #5659ce);
  border-radius: 60%;
  width: 25px;
  text-align: center;
}

/* .active {
  background: linear-gradient(right, #ff3fbb, #ff8891);
  border: none;
  border-radius: 30px;
} */

.section-item {
  cursor: pointer;
}
.botn {
  width: 140px;
  font-size: 30px;
  font-weight: bold;
  border-radius: 20px;
  height: 45px;
  outline: none;
  transition: all 0.3s ease;
  border: none;
  margin-top: 10px;
}
.botn-blue {
  position: relative;
  color: white;
  text-align: center;
  background: linear-gradient(to right, #05cefc, #5659ce);
}
.botn-red {
  position: relative;
  color: white;
  text-align: center;
  background: linear-gradient(right, #ff3fbb, #ff8891);
}
.image-container {
  text-align: center;
}
.options-btn {
  width: 100px;
  border-radius: 30px;
  border: none;
  margin-left: 5px;
  background: #fff;
  border: 1px solid #c1c2c5;
}
.title-price {
  display: flex;
  justify-content: space-between;
}
.images-slid {
  display: flex;
  justify-content: space-around;
}

.options {
  margin-top: 40px;
}
.title {
  font-weight: bold;
}

.card-new {
  width: 25%;
  margin-bottom: 13px;
  border-radius: 10px;
  padding: 12px 12px;
  overflow: hidden;
  box-shadow: none !important;
  -moz-box-shadow: none !important;
  -webkit-box-shadow: none !important;
}

.img-new {
  width: 100%;
}

.img-div {
  position: relative;
  text-align: center;
  margin-bottom: 10px;
  line-height: 0;
  width: 100%;
  overflow: hidden;
}

.card-img-new {
  max-height: 100%;
  max-width: 100%;
}

.title-new {
  height: auto;
  line-height: 18px;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  color: black;
  font-size: 14px;
  font-weight: bold;
}

.price-new {
  overflow: hidden;
  display: block;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.price-span {
  margin-right: 4px;
  font-size: 16px;
  font-weight: 700;
  height: 18px;
  line-height: 18px;
  color: #333;
  vertical-align: middle;
  font-weight: 700;
}
.add-to-cart {
  text-align: center;
  padding: 5px 10px 5px 10px;
  color: white;
  border: none;
  border-radius: 25px;
  font-size: 1rem;
  font-weight: bold;
}

.sub-title {
  font-weight: normal;
  font-size: 20px;
  display: block;
}

.paragraph {
  font-size: 22px;
  letter-spacing: 0.5px;
  margin-top: 10px;
}
.VueCarousel-pagination {
  display: none;
}
.brands-container {
  align-items: center;
  border: none;
}

.brands {
  width: 11rem;
}

.changeQTY .qtyy:hover {
  color: white;
}

@media screen and (max-width: 1200px) {
  .card-new {
    width: 50%;
  }
}

@media screen and (max-width: 700px) {
  .card-new {
    width: 100%;
  }
}
.fadeHeight-enter-active,
.fadeHeight-leave-active {
  transition: all 0.4s;
  max-height: 600px;
}
.fadeHeight-enter,
.fadeHeight-leave-to {
  opacity: 0.1;
  max-height: 0px;
}
</style>
